<div class="faq-page-wrapper">
  <div class="select-gamemode">
    <button class="button black medium-2" (click)="changeCategory('general')" [class.selected]="currentCategory === 'general'">General</button>
    <button class="button black medium-2" (click)="changeCategory('case-battles')" [class.selected]="currentCategory === 'case-battles'">Case Battles</button>
    <button class="button black medium-2" (click)="changeCategory('coinflip')" [class.selected]="currentCategory === 'coinflip'">Coinflip</button>
    <button class="button black medium-2" (click)="changeCategory('king')" [class.selected]="currentCategory === 'king'">King</button>
    <button class="button black medium-2" (click)="changeCategory('jackpot')" [class.selected]="currentCategory === 'jackpot'">Jackpot</button>
    <button class="button black medium-2" (click)="changeCategory('case-opening')" [class.selected]="currentCategory === 'case-opening'">Case Opening</button>
    <button class="button black medium-2" (click)="changeCategory('plinko')" [class.selected]="currentCategory === 'plinko'">Plinko</button>
    <button class="button black medium-2" (click)="changeCategory('mines')" [class.selected]="currentCategory === 'mines'">Mines</button>
    <button class="button black medium-2" (click)="changeCategory('towers')" [class.selected]="currentCategory === 'towers'">Towers</button>
    <button class="button black medium-2" (click)="changeCategory('affiliates')" [class.selected]="currentCategory === 'affiliates'">Affiliates</button>
  </div>

  <h2 class="title">FAQ</h2>

  @if (currentCategoryInfo) {
  <div class="question-section">
    <h3 class="subtitle">{{ currentCategoryInfo.title }}</h3>

    @for (item of currentCategoryInfo; track item.question){
    <div class="card" [class.expanded]="item.expanded">
      <div class="question" (click)="toggleAccordion(item)">
        {{ item.question }}
        <app-icon [width]="16" [icon]="'arrow'"></app-icon>
      </div>
      <div class="answer">
        <div class="answer-content">{{ item.answer }}</div>
      </div>
    </div>
    }
  </div>
  }
</div>
